/**
 * @generated SignedSource<<3d4f7a8d4d350c0d6845aa342338a2d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPromoCode_displayInfo$data = {
  readonly pricing: {
    readonly showNet: boolean | null;
    readonly showSale: boolean | null;
  } | null;
  readonly " $fragmentType": "PdpSharedPromoCode_displayInfo";
};
export type PdpSharedPromoCode_displayInfo$key = {
  readonly " $data"?: PdpSharedPromoCode_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPromoCode_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPromoCode_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "kind": "LinkedField",
      "name": "pricing",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showSale",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showNet",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "e9794f3d1b7d5470b139290c49f7b040";

export default node;
